export var ContentConsentTypeEnum;
(function (ContentConsentTypeEnum) {
    ContentConsentTypeEnum["TermsAndConditions"] = "Terms and Conditions";
    ContentConsentTypeEnum["DataPermissionsAgreement"] = "Data Permissions Agreement";
    ContentConsentTypeEnum["PersonalInformationAgreement"] = "Personal Information Agreement";
    ContentConsentTypeEnum["ConsentAgreement"] = "Consent Agreement";
    ContentConsentTypeEnum["CommitmentAgreement"] = "Commitment Agreement";
    ContentConsentTypeEnum["IndemnityAgreement"] = "Indemnity Agreement";
    ContentConsentTypeEnum["PhotoPermissions"] = "Photo Permissions";
    ContentConsentTypeEnum["PermissionToShare"] = "Permission to Share Information";
})(ContentConsentTypeEnum || (ContentConsentTypeEnum = {}));
export var ContentTypeEnum;
(function (ContentTypeEnum) {
    ContentTypeEnum[ContentTypeEnum["Consent"] = 14] = "Consent";
    ContentTypeEnum[ContentTypeEnum["Connect"] = 27] = "Connect";
    ContentTypeEnum[ContentTypeEnum["ConnectItem"] = 28] = "ConnectItem";
    ContentTypeEnum[ContentTypeEnum["Natal"] = 29] = "Natal";
    ContentTypeEnum[ContentTypeEnum["NatalInfo"] = 30] = "NatalInfo";
    ContentTypeEnum[ContentTypeEnum["NatalVideo"] = 31] = "NatalVideo";
    ContentTypeEnum[ContentTypeEnum["NatalGraphic"] = 32] = "NatalGraphic";
    ContentTypeEnum[ContentTypeEnum["NatalHealth"] = 33] = "NatalHealth";
    ContentTypeEnum[ContentTypeEnum["DangerSign"] = 35] = "DangerSign";
})(ContentTypeEnum || (ContentTypeEnum = {}));
//# sourceMappingURL=content-types.js.map